import {connect} from 'react-redux';
import {AnswerStep as Component} from './AnswerStep';
import {selectDropdownOption} from '@learningblocks/protocol-redux/lib/Actions';

function mapStateToProps(state) {
  return {};
}

function mapDispatchToProps(dispatch) {
  return {
    selectOption: (params) => {
      dispatch(selectDropdownOption(params));
    },
  };
}

export const AnswerStep = connect(
  mapStateToProps,
  mapDispatchToProps
)(Component);
